import React from "react"

import pageComponent from "../common/page-component-hoc"

import Feed from "./knowledge-item/Feed"

import { feedKnowledgeItemRequest } from "../../actions/feed-actions"

import FeedKnowledgeListWidgetContainer from "./knowledge-list/FeedKnowledgeListWidgetContainer"
import FeedFilterWidgetContainer from "./knowledge-filter/FeedFilterWidgetContainer"

const FeedComponent = ({ isFilterActive }) => (
    <div className="widgets-container clearfix row">
        <div
            className="col-xs-12 col-md-6 col-lg-5 col-xl-4 widget-list"
            id="feeds-list"
        >
            {isFilterActive ? (
                <FeedFilterWidgetContainer />
            ) : (
                <FeedKnowledgeListWidgetContainer />
            )}
        </div>
        <Feed />
    </div>
)

export default pageComponent("feed", feedKnowledgeItemRequest)(FeedComponent)
